import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import {
  Collapse,
  Space,
  Typography,
  Card,
  Empty,
  Modal,
  Button,
  message,
  Spin,
  Checkbox,
  FloatButton,
  Tag,
  Divider,
  Input,
  List,
  Popconfirm,
  Select,
} from "antd";
import {
  CheckCircleOutlined,
  FileTextOutlined,
  IdcardOutlined,
  HomeOutlined,
  PlusOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import axios from "axios";
import {
  GET_GEO_ALL,
  HEADERS_EXPORT_BEN,
  POST_DOC_RESEND,
  POST_DOC_STATUS,
  POST_LAWSUIT_DETAIL,
} from "../../../API/apiUrls";
import dayjs from "dayjs";
import useLawyerNamesNew from "../../../../hook/UseLawyerNameNew";

const CheckingDocumentsEnforce = ({
  open,
  close,
  dataDefault,
  func,
  status,
}) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userCompany = localStorage.getItem("COMPANY_ID");
  const { nameLawyers, loadingUseLawyerNames } = useLawyerNamesNew({
    auto: true,
    toast: false,
  });

  const [loading, setLoading] = useState(false);
  const [checkedList, setCheckedList] = useState({});
  const scrollRef = useRef(null);
  const [dataLoadLawSuit, setDataLoadLawSuit] = useState(null);
  const [dataAsset, setDataAsset] = useState([]);
  const [dataWCC, setDataWCC] = useState([]);
  const [activeKey, setActiveKey] = useState([]);
  const [isModalAddAddressTr, setIsModalAddAddressTr] = useState(false);
  const [geoRawData, setGeoRawData] = useState(null);
  const [memoData, setMemoData] = useState(null);
  const [isModalDebtPayment, setIsModalDebtPayment] = useState(false);
  const [verifyList, setVerifyList] = useState({}); // ✅ เพิ่ม state สำหรับ checkbox ฝั่งขวา
  const [newMemoText, setNewMemoText] = useState(""); // หมายเหตุใหม่

  // ✅ โหลด GEO Data (ครั้งเดียว)
  // useEffect(() => {
  //   let isMounted = true;
  //   const controller = new AbortController();

  //   const loadGeoData = async () => {
  //     try {
  //       const res = await axios.get(GET_GEO_ALL, {
  //         headers: HEADERS_EXPORT_BEN,
  //         signal: controller.signal,
  //       });

  //       if (isMounted) {
  //         setGeoRawData(res.data);
  //         console.log("✅ geoRawData loaded");
  //       }
  //     } catch (error) {
  //       if (error.name !== "CanceledError" && isMounted) {
  //         console.error("❌ Error loading geo data:", error);
  //       }
  //     }
  //   };

  //   loadGeoData();
  //   return () => {
  //     isMounted = false;
  //     controller.abort();
  //   };
  // }, []);

  // ✅ โหลดข้อมูล Lawsuit
  // const loadLawsuitData = useCallback(async () => {
  //   if (!dataDefault) return null;

  //   setLoading(true);
  //   const controller = new AbortController();

  //   try {
  //     console.log("📋 Loading lawsuit data for:", dataDefault);

  //     const lawsuitRes = await axios.post(
  //       POST_LAWSUIT_DETAIL,
  //       {
  //         CONTNO: dataDefault.CONTNO,
  //         loanId: dataDefault.loanId,
  //         lawsuitId: dataDefault.lawsuitId || 0,
  //       },
  //       {
  //         headers: HEADERS_EXPORT_BEN,
  //         signal: controller.signal,
  //       },
  //     );

  //     if (lawsuitRes?.data) {
  //       console.log("✅ Lawsuit data loaded:", lawsuitRes.data);
  //       oldDataLawsuitDoc(lawsuitRes.data);
  //       setDataLoadLawSuit(lawsuitRes.data.lawsuit);
  //       setDataAsset(lawsuitRes.data.asset || []);
  //       setDataWCC(lawsuitRes.data.wcc || []);
  //       setMemoData(lawsuitRes.data.note || []);
  //       return lawsuitRes.data.lawsuit;
  //     } else {
  //       throw new Error("ไม่พบข้อมูลคดี");
  //     }
  //   } catch (error) {
  //     if (error.name !== "CanceledError") {
  //       console.error("❌ Error loading lawsuit:", error);
  //       const errorMsg = error.response?.data?.message || error.message;
  //       message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
  //       setDataLoadLawSuit(null);
  //       setDataAsset([]);
  //       setDataWCC([]);
  //     }
  //     return null;
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [dataDefault]);

  // ✅ โหลดข้อมูลเมื่อเปิด Modal
  // useEffect(() => {
  //   if (!open) return;

  //   // Reset checked list เมื่อเปิด modal
  //   setCheckedList({});
  //   loadLawsuitData();
  // }, [open, loadLawsuitData]);

  // ⭐ NEW: โหลดข้อมูลเดิมเมื่อ status === 3
  const oldDataLawsuitDoc = (rawData) => {
    let initialCheckedList;
    if ((status === 3 || status === 6) && rawData?.lawsuit?.workLawsuitDoc) {
      const doc = rawData.lawsuit.workLawsuitDoc;
      const loanOld = rawData.lawsuit.loanOld; // ✅ เพิ่มตัวแปรนี้

      console.log("📝 โหลดข้อมูลเดิมจาก workLawsuitDoc:", doc);
      console.log("📝 ข้อมูล loanOld:", loanOld);

      // สร้าง initial checked list
      initialCheckedList = {
        contract: doc.docContno || false,
        property_docs: doc.docMainAsset || false,
        debtor_card: doc.docDebtorCard || false,
      };

      // ✅ โหลด verify list (ถ้ามี field ในฐานข้อมูล)
      const initialVerifyList = {
        contract_verify: doc.docContnoLawyer || false,
        property_docs_verify: doc.docMainAssetLawyer || false,
        debtor_card_verify: doc.docDebtorCardLawyer || false,
        notice_verify: doc.docNotifyLawyer || false,
        termination_verify: doc.docWccLawyer || false,
        id_cards_verify: doc.docCopyCardLawyer || false,
        tr14_verify: doc.docAddressTrLawyer || false,
      };

      if (doc.docCopyCard && rawData.asset) {
        // ✅ Tick ทุกคนโดยไม่ต้องแยกกลุ่ม
        rawData.asset.forEach((person) => {
          if (person.customerId) {
            initialCheckedList[`id_card_${person.customerId}`] = true;
          }
        });
      }

      if (doc.docAddressTr && loanOld) {
        // Tick ที่อยู่ ทร.14 ของผู้เช่าซื้อ
        if (loanOld.addressTr && loanOld.addressTr.length > 0) {
          const address = loanOld.addressTr[0];
          initialCheckedList[
            `tr14_${loanOld.CUSTOMER_ID}_${address.addrTrId}`
          ] = true;
        }

        // Tick ที่อยู่ ทร.14 ของผู้ค้ำทุกคน
        if (loanOld.guarantors && loanOld.guarantors.length > 0) {
          loanOld.guarantors.forEach((guarantor) => {
            if (guarantor.addressTr && guarantor.addressTr.length > 0) {
              const address = guarantor.addressTr[0];
              initialCheckedList[
                `tr14_${guarantor.CUSTOMER_ID}_${address.addrTrId}`
              ] = true;
            }
          });
        }
      }

      // 2. ถ้า docWcc = true ให้ tick บอกเลิกทุกรายการ
      if (doc.docWcc && rawData.wcc) {
        rawData.wcc.forEach((item) => {
          initialCheckedList[`termination_${item.id}`] = true;
        });
      }

      // 3. ถ้า docNotify มีค่า ให้ tick บอกกล่าวทุกรายการ
      if (doc.docNotify && rawData.wcc) {
        rawData.wcc.forEach((item) => {
          initialCheckedList[`notice_${item.id}`] = true;
        });
      }

      setCheckedList(initialCheckedList);
      setMemoData(doc.docMark || null);
      setVerifyList(initialVerifyList);

      console.log("✅ โหลดข้อมูลเดิมเสร็จสิ้น:", initialCheckedList);
    } else {
      initialCheckedList = {
        contract: true,
        property_docs: true,
        debtor_card: true,
      };
      setCheckedList(initialCheckedList);
    }
  };

  const handleCancel = () => {
    close();
  };

  const filterLawyersByCompany = useCallback((lawyers, userCompany) => {
    if (!Array.isArray(lawyers) || !userCompany) return [];

    const companyIds =
      userCompany === "1" || userCompany === "2" ? [1, 2] : [3];

    return lawyers.filter(
      (item) =>
        companyIds.includes(item.COMPANY_ID) &&
        (item.ROLE_ID === 3 || item.ROLE_ID === 4) &&
        item.ACTIVE_STATUS === 1,
    );
  }, []);

  const transformLawyersToOptions = useCallback((lawyers) => {
    return lawyers.map((item) => ({
      value: item.id,
      label: item.NNAME,
      data: item,
    }));
  }, []);

  const lawyersOption = useMemo(() => {
    if (!nameLawyers?.length || !userCompany) return [];

    const filtered = filterLawyersByCompany(nameLawyers, userCompany);
    const options = transformLawyersToOptions(filtered);

    return [...options];
  }, [
    nameLawyers,
    userCompany,
    filterLawyersByCompany,
    transformLawyersToOptions,
  ]);

  // const handleSave = async () => {
  //   setLoading(true);
  //   try {
  //     // ✅ รวบรวมสถานะ checkbox ทั้งหมด
  //     const checkboxStatus = {
  //       // Checkbox เดี่ยว
  //       contract: checkedList["contract"] || false,
  //       property_docs: checkedList["property_docs"] || false,
  //       debtor_card: checkedList["debtor_card"] || false,
  //       // loan_application: checkedList["loan_application"] || false,
  //       // Checkbox ใหญ่ (จาก useMemo)
  //       notice: noticeChecked,
  //       termination: terminationChecked,
  //       id_cards: idCardsChecked,
  //       tr14: tr14Checked,
  //     };

  //     console.log("📊 สถานะ checkbox ทั้งหมด:", checkboxStatus);

  //     // ✅ สร้าง payload สำหรับ API
  //     const payload = {
  //       docId:
  //         status === 3 || status === 6
  //           ? dataLoadLawSuit.workLawsuitDoc.docId
  //           : 0,
  //       lawsuitId: dataDefault.lawsuitId,
  //       loanId: dataDefault.loanId,
  //       docContno: checkboxStatus.contract ? true : false, // สัญญา
  //       docNotify: checkboxStatus.notice ? true : false, // บอกกล่าว
  //       docWcc: checkboxStatus.termination ? true : false, // บอกเลิก
  //       docMainAsset: checkboxStatus.property_docs ? true : false, // เอกสารหลักทรัพย์
  //       docDebtorCard: checkboxStatus.debtor_card ? true : false, // การ์ดลูกหนี้
  //       docCopyCard: checkboxStatus.id_cards ? true : false, // สำเนาบัตร
  //       docAddressTr: checkboxStatus.tr14,
  //       userId: userId,
  //       docMark: newMemoText,
  //     };

  //     console.log("📌 Payload ส่ง API:", payload);
  //     let apiUse = status === 6 ? POST_DOC_RESEND : POST_DOC_STATUS;
  //     const result = await postDocStatus(payload, apiUse);

  //     if (func) {
  //       func({
  //         action: "refresh",
  //         data: result,
  //       });
  //     }

  //     message.success(
  //       status === 3 || status === 6 ? "แก้ไขสำเร็จ" : "บันทึกสำเร็จ",
  //     );
  //     close();
  //   } catch (err) {
  //     console.error("❌ Error saving:", err);
  //     message.error(
  //       status === 3 || status === 6 ? "แก้ไขไม่สำเร็จ" : "บันทึกไม่สำเร็จ",
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // ✅ ฟังก์ชันส่งข้อมูลไป API
  const postDocStatus = async (payload, apiUse) => {
    console.log("📤 POST_DOC_STATUS with data:", payload);

    try {
      const res = await axios.post(apiUse, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      const { status, data } = res;

      if (status === 200) {
        console.log("✅ API Response:", data);
        return data;
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else if (status === 400) {
        message.error(`ข้อมูลไม่ถูกต้อง: ${serverMsg}`);
      } else if (status === 500) {
        message.error("เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ (500)");
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`,
        );
      }

      console.error("❌ postDocStatus error:", error);
      throw error;
    }
  };

  const handleCheckboxChange = useCallback((id, checked) => {
    setCheckedList((prev) => ({
      ...prev,
      [id]: checked,
    }));
  }, []);

  // ✅ Handler: Callback จาก AddAddressTr
  // const handleLoad = useCallback(
  //   async (data) => {
  //     console.log("📥 Callback from AddAddressTr:", data);

  //     if (data?.action === "refresh") {
  //       // ⭐ โหลดเฉพาะ lawsuit ใหม่
  //       await loadLawsuitData();
  //       message.success("อัพเดทข้อมูลที่อยู่ ทร.14 สำเร็จ");
  //     }
  //   },
  //   [loadLawsuitData],
  // );

  // ✅ ฟังก์ชันแปลง code เป็นชื่อ GEO
  const getGeoNameFromCode = useCallback(
    (provCode, distCode, subDistCode) => {
      let provName = null;
      let distName = null;
      let subDistName = null;

      if (geoRawData) {
        const province = geoRawData.province?.find(
          (p) => String(p.provCode) === String(provCode),
        );
        provName = province?.provDesc || null;

        if (province && distCode) {
          const district = geoRawData.district?.find(
            (d) =>
              String(d.provCode) === String(provCode) &&
              String(d.distCode) === String(distCode),
          );
          distName = district?.distDesc || null;
        }

        if (province && distCode && subDistCode) {
          const subDistrict = geoRawData.subDistrict?.find(
            (s) =>
              String(s.provCode) === String(provCode) &&
              String(s.distCode) === String(distCode) &&
              String(s.subDistCode) === String(subDistCode),
          );
          subDistName = subDistrict?.subDistDesc || null;
        }
      }

      return { provName, distName, subDistName };
    },
    [geoRawData],
  );

  // ✅ ฟังก์ชันสร้างที่อยู่เต็ม
  const formatFullAddress = useCallback(
    (address) => {
      const parts = [
        address.houseNumber,
        address.soi,
        address.road,
        address.village,
      ].filter(Boolean);

      const geoNames = getGeoNameFromCode(
        address.province,
        address.district,
        address.subdistrict,
      );

      const geoParts = [
        geoNames.subDistName,
        geoNames.distName,
        geoNames.provName,
        address.zipcode,
      ].filter(Boolean);

      return {
        address: parts.join(" "),
        geo: geoParts.join(" "),
        fullAddress: [...parts, ...geoParts].join(" "),
        province: geoNames.provName,
        district: geoNames.distName,
        subdistrict: geoNames.subDistName,
      };
    },
    [getGeoNameFromCode],
  );

  // ✅ ตรวจสอบว่าเป็นที่อยู่ที่ไม่เกิน 1 เดือน
  // const isWithinOneMonth = useCallback((createdAt) => {
  //   if (!createdAt) return false;
  //   const oneMonthAgo = dayjs().subtract(1, "month");
  //   return dayjs(createdAt).isAfter(oneMonthAgo);
  // }, []);

  // ✅ สร้างรายการ ทร.14 พร้อมกรองตามวันที่ (เฉพาะที่อยู่ล่าสุด 1 ที่อยู่)
  // const getTr14List = useCallback(() => {
  //   if (!dataLoadLawSuit?.loanOld) return [];

  //   const list = [];
  //   const loanOld = dataLoadLawSuit.loanOld;

  //   // ผู้เช่าซื้อ
  //   if (loanOld.addressTr && loanOld.addressTr.length > 0) {
  //     const borrower = dataAsset.find((item) => item.garno === 0);
  //     const borrowerMoney = borrower?.money;

  //     // ⭐ กรองเฉพาะที่อยู่ที่ไม่เกิน 1 เดือน
  //     const validAddresses = loanOld.addressTr.filter((addr) =>
  //       isWithinOneMonth(addr.CreatedAt),
  //     );

  //     // ⭐ เลือกเฉพาะที่อยู่ล่าสุด (1 ที่อยู่)
  //     if (validAddresses.length > 0) {
  //       const latestAddress = validAddresses.reduce((latest, current) => {
  //         return dayjs(current.CreatedAt).isAfter(dayjs(latest.CreatedAt))
  //           ? current
  //           : latest;
  //       });

  //       list.push({
  //         customerId: loanOld.CUSTOMER_ID,
  //         type: "borrower",
  //         garno: 0,
  //         name: borrower
  //           ? `${borrower.SNAM}${borrower.NAME1} ${borrower.NAME2}`
  //           : "ผู้เช่าซื้อ",
  //         addressTr: [
  //           {
  //             ...latestAddress,
  //             ...formatFullAddress(latestAddress),
  //           },
  //         ],
  //         money: borrowerMoney,
  //       });
  //     }
  //   }

  //   // ผู้ค้ำประกัน
  //   if (loanOld.guarantors && loanOld.guarantors.length > 0) {
  //     loanOld.guarantors.forEach((guarantor) => {
  //       if (guarantor.addressTr && guarantor.addressTr.length > 0) {
  //         const guarantorAsset = dataAsset.find(
  //           (item) => item.garno === guarantor.garno,
  //         );
  //         const guarantorMoney = guarantorAsset?.money;

  //         // ⭐ กรองเฉพาะที่อยู่ที่ไม่เกิน 1 เดือน
  //         const validAddresses = guarantor.addressTr.filter((addr) =>
  //           isWithinOneMonth(addr.CreatedAt),
  //         );

  //         // ⭐ เลือกเฉพาะที่อยู่ล่าสุด (1 ที่อยู่)
  //         if (validAddresses.length > 0) {
  //           const latestAddress = validAddresses.reduce((latest, current) => {
  //             return dayjs(current.CreatedAt).isAfter(dayjs(latest.CreatedAt))
  //               ? current
  //               : latest;
  //           });

  //           list.push({
  //             customerId: guarantor.CUSTOMER_ID,
  //             type: "guarantor",
  //             garno: guarantor.garno,
  //             name: guarantorAsset
  //               ? `${guarantorAsset.SNAM}${guarantorAsset.NAME1} ${guarantorAsset.NAME2}`
  //               : `ผู้ค้ำคนที่ ${guarantor.garno}`,
  //             relation: guarantor.RELATN,
  //             addressTr: [
  //               {
  //                 ...latestAddress,
  //                 ...formatFullAddress(latestAddress),
  //               },
  //             ],
  //             money: guarantorMoney,
  //           });
  //         }
  //       }
  //     });
  //   }

  //   return list;
  // }, [dataLoadLawSuit, dataAsset, isWithinOneMonth, formatFullAddress]);

  //เอาทั้งหมด

  const getTr14List = useCallback(() => {
    if (!dataLoadLawSuit?.loanOld) return [];

    const list = [];
    const loanOld = dataLoadLawSuit.loanOld;

    // ⭐ Helper: หาที่อยู่ล่าสุด
    const getLatestAddress = (addresses) => {
      if (!addresses || addresses.length === 0) return null;
      return addresses.reduce((latest, current) =>
        dayjs(current.CreatedAt).isAfter(dayjs(latest.CreatedAt))
          ? current
          : latest,
      );
    };

    // ═══════════════════════════════════════════
    // ผู้เช่าซื้อ
    // ═══════════════════════════════════════════
    if (loanOld.addressTr && loanOld.addressTr.length > 0) {
      const borrower = dataAsset.find((item) => item.garno === 0);
      const latestAddress = getLatestAddress(loanOld.addressTr); // ✅ ไม่ filter

      if (latestAddress) {
        list.push({
          customerId: loanOld.CUSTOMER_ID,
          type: "borrower",
          garno: 0,
          name: borrower
            ? `${borrower.SNAM}${borrower.NAME1} ${borrower.NAME2}`
            : "ผู้เช่าซื้อ",
          addressTr: [
            {
              ...latestAddress,
              ...formatFullAddress(latestAddress),
            },
          ],
          money: borrower?.money,
        });
      }
    }

    // ═══════════════════════════════════════════
    // ผู้ค้ำประกัน (ต้องแก้ตรงนี้!)
    // ═══════════════════════════════════════════
    if (loanOld.guarantors && loanOld.guarantors.length > 0) {
      loanOld.guarantors.forEach((guarantor) => {
        if (guarantor.addressTr && guarantor.addressTr.length > 0) {
          const guarantorAsset = dataAsset.find(
            (item) => item.garno === guarantor.garno,
          );

          // ✅ แก้ตรงนี้! - ไม่ filter, เอาล่าสุดเลย
          const latestAddress = getLatestAddress(guarantor.addressTr);

          if (latestAddress) {
            list.push({
              customerId: guarantor.CUSTOMER_ID,
              type: "guarantor",
              garno: guarantor.garno,
              name: guarantorAsset
                ? `${guarantorAsset.SNAM}${guarantorAsset.NAME1} ${guarantorAsset.NAME2}`
                : `ผู้ค้ำคนที่ ${guarantor.garno}`,
              relation: guarantor.RELATN,
              addressTr: [
                {
                  ...latestAddress,
                  ...formatFullAddress(latestAddress),
                },
              ],
              money: guarantorAsset?.money,
            });
          }
        }
      });
    }

    console.log("📋 tr14List result:", list); // ⭐ Debug
    return list;
  }, [dataLoadLawSuit, dataAsset, formatFullAddress]); // ✅ ลบ isWithinOneMonth

  // 1. คำพิพากษา
  const judgementData = useMemo(() => {
    return true;
  }, []);

  // 2. หมายคดีตั้ง
  const noticeChecked = useMemo(() => {
    const wccNotice = dataWCC.filter((item) => item.flagStatus === 1);
    const allNoticeIds = wccNotice.map((item) => item.id);

    if (allNoticeIds.length === 0) return false;

    const allChecked = allNoticeIds.every((id) => checkedList[`notice_${id}`]);

    console.log("✅ คำนวณ noticeChecked:", {
      totalNotices: allNoticeIds.length,
      allChecked,
    });

    return allChecked;
  }, [dataWCC, checkedList]);

  // 3. ทร.14
  const tr14Checked = useMemo(() => {
    const tr14List = getTr14List();

    // รวบรวม ID ของที่อยู่ทั้งหมด
    const allAddressIds = [];
    tr14List.forEach((person) => {
      person.addressTr.forEach((addr) => {
        allAddressIds.push(`tr14_${person.customerId}_${addr.addrTrId}`);
      });
    });

    if (allAddressIds.length === 0) return false;

    const allChecked = allAddressIds.every((id) => checkedList[id]);

    console.log("✅ คำนวณ tr14Checked:", {
      totalAddresses: allAddressIds.length,
      allChecked,
    });

    return allChecked;
  }, [getTr14List, checkedList]);

  const getCollapseItems = () => {
    const items = [];

    // 1. สัญญา (ไม่สามารถกดเปิดได้)
    items.push({
      key: "contract",
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Space>
            <Checkbox
              checked={checkedList["contract"]}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) =>
                handleCheckboxChange("contract", e.target.checked)
              }
              defaultChecked={true}
            />
            <FileTextOutlined />
            <Typography.Text strong>คำพิพากษา</Typography.Text>
          </Space>
          {status === 6 && (
            <Checkbox
              checked={verifyList["contract_verify"]}
              onClick={(e) => e.stopPropagation()}
              style={{ marginRight: 16 }}
              disabled
            >
              {verifyList["contract_verify"] ? (
                <CheckOutlined style={{ color: "#52c41a" }} />
              ) : (
                <CloseOutlined style={{ color: "#ff4d4f" }} />
              )}{" "}
              {verifyList["contract_verify"] ? "พบเอกสาร" : "ไม่พบเอกสาร"}
            </Checkbox>
          )}
        </div>
      ),
      collapsible: "disabled",
      showArrow: false,
    });

    items.push({
      key: "property_docs",
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Space>
            <Checkbox
              checked={checkedList["property_docs"]}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) =>
                handleCheckboxChange("property_docs", e.target.checked)
              }
              defaultChecked={true}
            />
            <HomeOutlined />
            <Typography.Text strong>หมายคดีตั้ง</Typography.Text>
          </Space>
          {status === 6 && (
            <Checkbox
              checked={verifyList["property_docs_verify"]}
              onClick={(e) => e.stopPropagation()}
              style={{ marginRight: 16 }}
              disabled
            >
              {verifyList["property_docs_verify"] ? (
                <CheckOutlined style={{ color: "#52c41a" }} />
              ) : (
                <CloseOutlined style={{ color: "#ff4d4f" }} />
              )}{" "}
              {verifyList["property_docs_verify"] ? "พบเอกสาร" : "ไม่พบเอกสาร"}
            </Checkbox>
          )}
        </div>
      ),
      collapsible: "disabled",
      showArrow: false,
    });
    // 6. สำเนาบัตร ทุกคน (มี nested checkbox)
    const mainBorrower = dataAsset.find(
      (item) => item.garno === 0 && !item.relationCustomerId,
    );

    const borrowerRelations = dataAsset.filter(
      (item) => item.relationCustomerId === mainBorrower?.customerId,
    );

    const mainGuarantors = dataAsset.filter(
      (item) => item.garno > 0 && !item.relationCustomerId,
    );

    items.push({
      key: "id_cards",
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Space>
            <Checkbox
              // checked={judgementData}
              onClick={(e) => e.stopPropagation()}
              // disabled
            />
            <IdcardOutlined />
            <Typography.Text strong>
              คัด ทร.14{" "}
              <Tag color="cyan" style={{ marginLeft: 8 }}>
                {dataAsset.length} คน
              </Tag>
            </Typography.Text>
          </Space>
          {status === 6 && (
            <Checkbox
              checked={verifyList["id_cards_verify"]}
              onClick={(e) => e.stopPropagation()}
              style={{ marginRight: 16 }}
              disabled
            >
              {verifyList["id_cards_verify"] ? (
                <CheckOutlined style={{ color: "#52c41a" }} />
              ) : (
                <CloseOutlined style={{ color: "#ff4d4f" }} />
              )}{" "}
              {verifyList["id_cards_verify"] ? "พบเอกสาร" : "ไม่พบเอกสาร"}
            </Checkbox>
          )}
        </div>
      ),
      children: (
        <Card size="small">
          {/* ✅ 1. ผู้เช่าซื้อและคนที่เกี่ยวข้อง */}
          <div style={{ marginBottom: 12 }}>
            <Typography.Text strong>1. ผู้เช่าซื้อ</Typography.Text>
            {mainBorrower ? (
              <>
                {/* ผู้เช่าซื้อหลัก */}
                <div style={{ marginLeft: 16, marginTop: 4 }}>
                  <Space>
                    <Checkbox
                      checked={
                        checkedList[`id_card_${mainBorrower.customerId}`]
                      }
                      onChange={(e) =>
                        handleCheckboxChange(
                          `id_card_${mainBorrower.customerId}`,
                          e.target.checked,
                        )
                      }
                    />
                    <Typography.Text>
                      {mainBorrower.SNAM}
                      {mainBorrower.NAME1} {mainBorrower.NAME2}
                    </Typography.Text>
                  </Space>
                  <div style={{ marginLeft: 40 }}>
                    <Typography.Text type="secondary" style={{ fontSize: 14 }}>
                      เลขบัตรประชาชน: {mainBorrower.CUSCOD}
                    </Typography.Text>
                  </div>
                </div>

                {/* ✅ คนที่เกี่ยวข้องกับผู้เช่าซื้อ (คู่สมรส/ญาติ) */}
                {borrowerRelations.length > 0 &&
                  borrowerRelations.map((relation) => (
                    <div
                      key={relation.customerId}
                      style={{ marginLeft: 40, marginTop: 8 }}
                    >
                      <Space>
                        <Checkbox
                          checked={
                            checkedList[`id_card_${relation.customerId}`]
                          }
                          onChange={(e) =>
                            handleCheckboxChange(
                              `id_card_${relation.customerId}`,
                              e.target.checked,
                            )
                          }
                        />
                        <Typography.Text>
                          {relation.SNAM}
                          {relation.NAME1} {relation.NAME2}
                          <Tag color="green" style={{ marginLeft: 8 }}>
                            {relation.relation}
                          </Tag>
                        </Typography.Text>
                      </Space>
                      <div style={{ marginLeft: 40 }}>
                        <Typography.Text
                          type="secondary"
                          style={{ fontSize: 14 }}
                        >
                          เลขบัตรประชาชน: {relation.CUSCOD}
                        </Typography.Text>
                      </div>
                    </div>
                  ))}
              </>
            ) : (
              <Typography.Text type="secondary">ไม่พบข้อมูล</Typography.Text>
            )}
          </div>

          <Divider style={{ margin: "12px 0" }} />

          {/* ✅ 2. ผู้ค้ำและคนที่เกี่ยวข้อง */}
          <div>
            <Typography.Text strong>
              2. คนค้ำประกัน ({mainGuarantors.length} คน)
            </Typography.Text>
            {mainGuarantors.length > 0 ? (
              mainGuarantors.map((guarantor, index) => {
                // ✅ หาคนที่เกี่ยวข้องกับผู้ค้ำคนนี้
                const guarantorRelations = dataAsset.filter(
                  (item) => item.relationCustomerId === guarantor.customerId,
                );

                return (
                  <div key={guarantor.customerId} style={{ marginTop: 8 }}>
                    {/* ผู้ค้ำหลัก */}
                    <div style={{ marginLeft: 16 }}>
                      <Space>
                        <Checkbox
                          checked={
                            checkedList[`id_card_${guarantor.customerId}`]
                          }
                          onChange={(e) =>
                            handleCheckboxChange(
                              `id_card_${guarantor.customerId}`,
                              e.target.checked,
                            )
                          }
                        />
                        <Typography.Text>
                          {index + 1}. {guarantor.SNAM}
                          {guarantor.NAME1} {guarantor.NAME2}
                        </Typography.Text>
                      </Space>
                      <div style={{ marginLeft: 40 }}>
                        <Typography.Text
                          type="secondary"
                          style={{ fontSize: 14 }}
                        >
                          เลขบัตรประชาชน: {guarantor.CUSCOD}
                        </Typography.Text>
                      </div>
                    </div>

                    {/* ✅ คนที่เกี่ยวข้องกับผู้ค้ำ (ถ้ามี) */}
                    {guarantorRelations.length > 0 &&
                      guarantorRelations.map((relation) => (
                        <div
                          key={relation.customerId}
                          style={{ marginLeft: 40, marginTop: 8 }}
                        >
                          <Space>
                            <Checkbox
                              checked={
                                checkedList[`id_card_${relation.customerId}`]
                              }
                              onChange={(e) =>
                                handleCheckboxChange(
                                  `id_card_${relation.customerId}`,
                                  e.target.checked,
                                )
                              }
                            />
                            <Typography.Text>
                              {relation.SNAM}
                              {relation.NAME1} {relation.NAME2}
                              <Tag color="green" style={{ marginLeft: 8 }}>
                                {relation.relation}
                              </Tag>
                            </Typography.Text>
                          </Space>
                          <div style={{ marginLeft: 40 }}>
                            <Typography.Text
                              type="secondary"
                              style={{ fontSize: 14 }}
                            >
                              เลขบัตรประชาชน: {relation.CUSCOD}
                            </Typography.Text>
                          </div>
                        </div>
                      ))}

                    {index < mainGuarantors.length - 1 && (
                      <Divider style={{ margin: "12px 0" }} />
                    )}
                  </div>
                );
              })
            ) : (
              <Typography.Text type="secondary">ไม่มีคนค้ำ</Typography.Text>
            )}
          </div>
        </Card>
      ),
    });

    return items;
  };

  // ✅ สร้างข้อความแสดงชื่อผู้เช่าซื้อและผู้ค้ำ
  const getHeaderInfo = () => {
    const borrower = dataAsset.find((item) => item.garno === 0);
    const guarantors = dataAsset.filter((item) => item.garno > 0);

    return (
      <div>
        <div>
          <Typography.Text strong>เลขที่สัญญา: </Typography.Text>
          <Tag color="blue">{dataDefault?.CONTNO}</Tag>
          {status === 3 ? (
            <Tag color="orange" style={{ marginLeft: 8 }}>
              แก้ไข
            </Tag>
          ) : status === 6 ? (
            <Tag color="orange" style={{ marginLeft: 8 }}>
              เอกสารตีกลับ
            </Tag>
          ) : null}
        </div>
        {borrower && (
          <div style={{ marginTop: 4 }}>
            <Typography.Text strong>ผู้เช่าซื้อ: </Typography.Text>
            <Typography.Text>
              {borrower.SNAM}
              {borrower.NAME1} {borrower.NAME2}
            </Typography.Text>
          </div>
        )}
        {guarantors.length > 0 && (
          <div style={{ marginTop: 4 }}>
            <Typography.Text strong>ผู้ค้ำประกัน: </Typography.Text>
            {guarantors.map((guarantor, index) => (
              <span key={guarantor.customerId}>
                {guarantor.SNAM}
                {guarantor.NAME1} {guarantor.NAME2}
                {index < guarantors.length - 1 ? ", " : ""}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <Modal
      title={
        <Space>
          <CheckCircleOutlined style={{ color: "#52c41a" }} />
          <span>
            {status === 3
              ? "แก้ไขเอกสาร"
              : status === 6
                ? "เอกสารตีกลับ"
                : "เตรียมเอกสารลงพื้นที่"}
          </span>
        </Space>
      }
      open={open}
      onCancel={handleCancel}
      width={800}
      maskClosable={false}
      centered
      footer={[
        <Button key="back" onClick={handleCancel} danger>
          ปิด
        </Button>,
        <Popconfirm
          title="ยืนยัน"
          description="คุณต้องการบันทึกใช่หรือไม่ ?"
          // onConfirm={handleSave}
          onCancel={null}
          okText="ยืนยัน"
          cancelText="ยกเลิก"
        >
          <Button key="save" type="primary" loading={loading}>
            {status === 3 || status === 6 ? "บันทึกการแก้ไข" : "บันทึก"}
          </Button>
        </Popconfirm>,
      ]}
    >
      <div
        ref={scrollRef}
        style={{
          maxHeight: "70vh",
          overflowY: "auto",
          paddingRight: 8,
        }}
      >
        <Spin spinning={loading}>
          {/* {dataLoadLawSuit ? ( */}
          <>
            <Card
              size="small"
              style={{ marginBottom: 16, backgroundColor: "#f0f5ff" }}
            >
              {getHeaderInfo()}
            </Card>
            <Collapse
              items={getCollapseItems()}
              activeKey={activeKey}
              onChange={setActiveKey}
              style={{ marginBottom: 16 }}
            />
            {/* แสดงรายการหมายเหตุที่มีอยู่แล้ว */}
            {memoData?.length > 0 && (
              <>
                <Divider orientation="left">
                  <Space>
                    <Typography.Text strong>หมายเหตุก่อนหน้า</Typography.Text>
                    <Tag color="blue">{memoData.length} รายการ</Tag>
                  </Space>
                </Divider>
                <List
                  style={{ marginBottom: 16 }}
                  bordered
                  dataSource={memoData}
                  renderItem={(item, index) => (
                    <List.Item>
                      <List.Item.Meta
                        // avatar={
                        //   <Avatar style={{ backgroundColor: "#1890ff" }}>
                        //     {item.USERNAME?.charAt(0).toUpperCase()}
                        //   </Avatar>
                        // }
                        title={
                          <Space>
                            <Typography.Text strong>
                              {item.USERNAME} :
                            </Typography.Text>
                            <Typography.Text
                              type="secondary"
                              style={{ fontSize: 12 }}
                            >
                              {dayjs(item.CreatedAt).format("DD/MM/YYYY HH:mm")}
                            </Typography.Text>
                          </Space>
                        }
                        description={item.note}
                      />
                    </List.Item>
                  )}
                />
              </>
            )}
            <Divider orientation="left">
              <Typography.Text strong>เลือกผู้รับผิดชอบ</Typography.Text>
            </Divider>
            <Select
              placeholder="เลือกผู้สืบทรัพย์"
              options={lawyersOption}
              loading={loadingUseLawyerNames}
              showSearch
              optionFilterProp="label"
              disabled={!lawyersOption.length}
              size="large"
            />
            <Divider orientation="left">
              <Typography.Text strong>เพิ่มหมายเหตุใหม่</Typography.Text>
            </Divider>
            <Input.TextArea
              value={newMemoText}
              onChange={(e) => setNewMemoText(e.target.value)}
              rows={3}
              placeholder="กรอกหมายเหตุใหม่..."
              maxLength={500}
              showCount
            />
          </>
          {/* ) : (
            <Empty description="ไม่มีข้อมูล" />
          )} */}
        </Spin>

        <FloatButton.BackTop
          target={() => scrollRef.current}
          visibilityHeight={80}
          style={{ right: 16, bottom: 16 }}
        />
      </div>
    </Modal>
  );
};

export default CheckingDocumentsEnforce;
